"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeSpot = exports.Spot = void 0;

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _uuid = require("./uuid");

var _store = require("./store");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Spot = /*#__PURE__*/function () {
  function Spot(baseUrl, debug) {
    var _this = this;

    _classCallCheck(this, Spot);

    this.store = void 0;
    this.subscriptions = void 0;
    this.waitForQuery = void 0;

    this.query = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(endpoint) {
        var params,
            path,
            config,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                path = _args.length > 2 && _args[2] !== undefined ? _args[2] : [endpoint, JSON.stringify(params)];
                config = _args.length > 3 ? _args[3] : undefined;

                _this.store.dispatch({
                  type: 'QUERY',
                  payload: {
                    params: params,
                    endpoint: endpoint,
                    path: path
                  },
                  config: config,
                  metadata: {
                    correlationId: (0, _uuid.uuidv4)()
                  }
                });

                _context.next = 6;
                return _this.waitForQuery();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    this.command = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(endpoint, params, config) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.store.dispatch({
                  type: 'COMMAND',
                  payload: {
                    params: params,
                    endpoint: endpoint
                  },
                  config: config,
                  metadata: {
                    correlationId: (0, _uuid.uuidv4)()
                  }
                });

                _context2.next = 3;
                return _this.waitForQuery();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }();

    this.subscribeOnce = function (subscription) {
      var hash = (0, _uuid.uuidv4)();

      _this.subscriptions[hash] = function (state) {
        subscription(state);
        delete _this.subscriptions[hash];
      };
    };

    this.get = function (path) {
      var state = _this.data;

      while (path.length) {
        var next = path.shift(); // Ye, these are nasty, but i'm abusing json objects here and need the flexibility. -dgoemans

        /* eslint-disable @typescript-eslint/no-non-null-assertion */

        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */

        state = state[next];
      }

      return (0, _deepmerge["default"])({}, state);
    };

    this.store = (0, _store.makeStore)(debug);
    this.subscriptions = {};

    this.waitForQuery = function () {
      return new Promise(_this.subscribeOnce);
    };

    this.store.dispatch({
      type: 'SETUP',
      payload: {
        baseUrl: baseUrl
      }
    });
    this.store.subscribe(function () {
      if (!_this.store.getState().data.loading) {
        Object.values(_this.subscriptions).forEach(function (sub) {
          sub(_this.data);
        });
      }
    });
  }

  _createClass(Spot, [{
    key: "data",
    get: function get() {
      return (0, _deepmerge["default"])({}, this.store.getState().data);
    }
  }, {
    key: "errors",
    get: function get() {
      return _toConsumableArray(this.store.getState().errors);
    }
  }]);

  return Spot;
}();

exports.Spot = Spot;

var initializeSpot = function initializeSpot(baseUrl) {
  var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Spot(baseUrl, debug);
};

exports.initializeSpot = initializeSpot;